//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;

var data = require("./map2.geo.json");

//ICH code for popup template if needed----------
var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

function commafy( num ) {
 num = num.toString();
 if (!num) return;
 if (num.length >= 4) {
   num = num.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
 }
 return num;
}
function highlightFeature(e) {
    var layer = e.target;

    layer.setStyle({
        weight: 3,
        color: '#666'
    });

    if (!L.Browser.ie && !L.Browser.opera) {
        layer.bringToFront();
    }
}
function resetHighlight(e) {
    geojson.resetStyle(e.target);
}

var onEachFeature = function(feature, layer) {
  // feature.properties.contributions2 = commafy(feature.properties.contributions);
  feature.properties.total_amount2 = commafy(feature.properties.total_amount);
  feature.properties.rate_per_1000_pop2 = commafy(Number(feature.properties.rate_per_1000_pop));
  if (feature.properties.contributions){
  layer.bindPopup(ich.popup(feature.properties))
};
layer.on({
       mouseover: highlightFeature,
       mouseout: resetHighlight
   });
};

map.scrollWheelZoom.disable();

function getColor(d) {
  return d >= 1800 ? '#006837' :
    d >= 1350 ? '#31a354' :
    d >= 900 ? '#78c679' :
    d >= 450 ? '#c2e699' :
    d > 0 ? '#ffffcc' :
    'transparent';
}

function style(feature) {
  return {
    fillColor: getColor(feature.properties.rate_per_1000_pop),
    weight: 1,
    opacity: 1,
    color: 'white',
    fillOpacity: 0.7
  };
}

var geojson = L.geoJson(data, {
  style: style,
  onEachFeature: onEachFeature
}).addTo(map);
